module.exports = __webpack_public_path__ + "img/nft1.1ded57fc.jpg";